//Make sure controller & component names are different from portal's!
(function (ng, app) {
    app.config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('Onboarding.CarrierSetup',
                {
                    url: '/CarrierSetup',
                    component: 'carrierSetupComponent',
                });
        }
    ]);

    app.component('carrierSetupComponent', {
        templateUrl: 'App.Onboarding/States/CarrierSetup/CarrierSetup.template.html',
        controller: 'CarrierSetupController',
        bindings: {
            user: '<',
            userGroup: '<',
            onBehalfOfUserGroup: '<',
            completedSureLc: "="
        }
    });

    app.controller('CarrierSetupController', CarrierSetupController);

    CarrierSetupController.$inject = ['externalLoading', 'onboardingApi', 'permissionApi', 'permissionService', 'ssoApi', 'userApi', '$window'];

    function CarrierSetupController(externalLoading, onboardingApi, permissionApi, permissionService, ssoApi, userApi, $window) {
        var $ctrl = this;

        $ctrl.checklist = ['Scan of your E&O', 'Scan of a voided check', 'EIN &amp; business address'];

        //$ctrl.goToSureLc = function () {
        //    // Todo: figure out what this code does (copied from the App.Portal CarriersTraining)
        //    // Not sure if onBehalfOfUserGroup and userGroup are being populated
        //    $ctrl.userGroup = $ctrl.onBehalfOfUserGroup || $ctrl.userGroup;

        //    if ($ctrl.userGroup && $ctrl.userGroup.AffiliationLink) {
        //        $window.open($ctrl.userGroup.AffiliationLink);
        //    }

        //    else {
        //        var w = $window.open();
        //        w.document.write(externalLoading.html);

        //        ssoApi.initiateSureLcSso($ctrl.sureLcUser.LastName).then(function (data) {
        //            w.document.write(data);
        //            w.document.forms.surelc.submit();
        //        }, function (error) {
        //            w.document.write(" Failed.  There was an error accessing this resource.");
        //        });
        //    }
        //    $ctrl.completeContracting();
        //};

        //$ctrl.completeContracting = function () {
        //    // Post to Onboarding api to complete contracting
        //    onboardingApi.updateContractingCompleted().finally(function () {
        //        $ctrl.completedSureLc = true;
        //        //update permissions
        //        userApi.updateOnboardingCompletedPermissions($ctrl.user.Id).then(function () {
        //            // update permissions cookie
        //            permissionApi.getPolicyStatements().then(function (response) {
        //                permissionService.setPermissions(response);
        //            });
        //        });
        //    });
        //};

        $ctrl.$onInit = function () {
            //ssoApi.getSureLcUser().then(function (user) {
            //    $ctrl.sureLcUser = user;
            //});
            //onboardingApi.getContractingCompleted().then(function (response) {
            //    $ctrl.completedSureLc = response;
            //});
        };
    }
})(window.angular, window.app);